import { defineComponent as _defineComponent } from 'vue'

  import Modal from "@/components/ui/Modal.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ReservationInstructionsModal',
  props: {
    isOpen: {
      type: Boolean,
      required: false,
    },
    lotTitle: {
      type: String,
      required: true,
    },
    estateTitle: {
      type: String,
      required: true,
    },
    transitionName: {
      type: String,
    },
  },
  emits: [
    "close",
    "openLoginModal",
    "openRegistrationModal",
  ],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;

  const props = __props;

  const onClose = () => {
    emits("close");
  };

  const openLoginModal = () => {
    onClose();
    emits("openLoginModal");
  };

  const openRegistrationModal = () => {
    onClose();
    emits("openRegistrationModal");
  };

const __returned__ = { emits, props, onClose, openLoginModal, openRegistrationModal, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})